
import imageCompression from 'browser-image-compression';

interface CompressImageOptions {
  maxSizeMB: number;
  maxWidthOrHeight?: number;
  useWebWorker?: boolean;
  initialQuality?: number;
}

const defaultOptions: CompressImageOptions = {
  maxSizeMB: 0.3, // 300KB
  maxWidthOrHeight: 1920, // Optional: resize images to a max width/height
  useWebWorker: true,
  initialQuality: 0.8, // Start with a reasonable quality
};

/**
 * Compresses an image file.
 * @param {File} file - The image file to compress.
 * @param {Partial<CompressImageOptions>} options - Compression options.
 * @returns {Promise<File>} - The compressed image file.
 */
export const compressImage = async (file: File, options: Partial<CompressImageOptions> = {}): Promise<File> => {
  const compressionOptions = {
    ...defaultOptions,
    ...options,
  };

  console.log(`Compressing ${file.name}, original size: ${(file.size / 1024 / 1024).toFixed(2)} MB`);

  try {
    const compressedBlob = await imageCompression(file, compressionOptions);
    const compressedFile = new File([compressedBlob], file.name, {
      type: file.type,
      lastModified: Date.now(),
    });
    console.log(`Compressed ${compressedFile.name}, new size: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`);
    return compressedFile;
  } catch (error) {
    console.error(`Error compressing image ${file.name}:`, error);
    // If compression fails, return the original file or throw error
    // For now, let's throw the error so it can be handled upstream
    throw new Error(`Failed to compress image ${file.name}.`);
  }
};
